"use strict";

import BaseModel from "dias/core/models/baseModel";

class ServiceLog extends BaseModel {
  constructor() {
    super("servicelogs", {});
  }
}

export default ServiceLog;
